<logro-edit-view [logroId]="logroID"></logro-edit-view>
